"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=paginated-response-type.js.map